import styled from '@emotion/styled';
import { Menu, Avatar, ButtonBase } from '@mui/material';

export const StyledMenu = styled(Menu)`
  && .MuiDivider-root {
    margin: 0;
    border-color: #dbdcde0d;
    border-bottom-width: 0.0625rem;
  }
  & .MuiPaper-root {
    border-radius: 0;
    background-color: ${({ theme }) => theme.palette.secondary.main};
    min-width: 16rem;
    color: ${({ theme }) => theme.palette.background.paper};
    & .MuiList-root {
      padding-top: 0;
      padding-bottom: 0;
    }
    & .MuiMenuItem-root {
      &:hover {
        background-color: ${({ theme }) => theme.palette.secondary.dark};
      }
    }
  }
`;

export const StyledIconButton = styled(ButtonBase)`
  background: ${({ active, theme }) => (active ? theme.palette.secondary.dark : 'transparent')};
  padding: 1rem;
  :hover {
    background-color: ${({ theme }) => theme.palette.secondary.dark};
  }
`;

export const StyledAvatar = styled(Avatar)`
  background: transparent;
  border: 0.1rem solid ${({ theme }) => theme.palette.contrastText};
  color: ${({ theme }) => theme.palette.contrastText};
  font-size: 0.625rem;
  font-weight: 600;
  height: 1.5rem;
  width: 1.5rem;
`;
